import React from "react";

const PlaceHolder = () => (
    <h5 className="card-title placeholder-glow">
        <span className="placeholder bg-secondary w-100 col-12"></span>
    </h5>
);

export default PlaceHolder;
